const INVESTOR_IPO_DISCLAIMER_TRANSITION_DURATION = 300;

class InvestorIpoDisclaimerModal extends ModalBase {
  get modalTransition() {
    return {
      overlayOpenClasses: ['opacity-100'],
      overlayClosedClasses: ['opacity-0'],
      panelOpenClasses: ['opacity-100', 'max-lg:translate-y-0', 'lg:scale-100'],
      panelClosedClasses: ['opacity-0', 'max-lg:translate-y-full', 'lg:scale-95'],
      transitionDuration: INVESTOR_IPO_DISCLAIMER_TRANSITION_DURATION,
    };
  }

  constructor() {
    super();
    this.previousActiveElement = null;
    this.isOpen = false;
    this.focusTrapHandler = null;
    this.onConfirmCallback = null;
  }

  connectedCallback() {
    this.overlay = this.querySelector('[data-investor-ipo-disclaimer-overlay]');
    this.panel = this.querySelector('[data-investor-ipo-disclaimer-panel]');

    this.overlay?.addEventListener('click', () => this.close());

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-investor-ipo-disclaimer-cancel]')) this.close();
    });

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-investor-ipo-disclaimer-confirm]')) this.confirm();
    });

    this.handleKeydown = (event) => {
      if (event.key === 'Escape' && this.isOpen) this.close();
    };
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeydown);
    this.removeTrapFocus();
  }

  open(onConfirmCallback) {
    this.onConfirmCallback = onConfirmCallback;
    this.openModal();
  }

  confirm() {
    const callback = this.onConfirmCallback;
    this.onConfirmCallback = null;
    this.closeModal(() => callback?.());
  }

  close() {
    this.onConfirmCallback = null;
    this.closeModal();
  }
}

if (!customElements.get('investor-ipo-disclaimer-modal')) {
  customElements.define('investor-ipo-disclaimer-modal', InvestorIpoDisclaimerModal);
}

// accordion.js can't be modified (shared by 13 sections theme-wide) and attaches
// its toggle listener directly on the trigger with no hook to intercept it —
// so this gate runs in the capture phase on document, ahead of that listener,
// and fully suppresses the click for a first, unconfirmed open attempt.
if (!document.documentElement.dataset.investorIpoDrhpBound) {
  document.documentElement.dataset.investorIpoDrhpBound = 'true';

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('[data-accordion-trigger]');
      if (!trigger) return;

      const gate = trigger.closest('[data-ipo-drhp-gate]');
      if (!gate) return;
      if (gate.dataset.ipoDrhpConfirmed === 'true') return;

      const isCurrentlyOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isCurrentlyOpen) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const modal = document.querySelector('investor-ipo-disclaimer-modal');
      modal?.open(() => {
        gate.dataset.ipoDrhpConfirmed = 'true';
        trigger.click();
      });
    },
    true,
  );
}
